package app.bloomey.web.modules.video

import app.bloomey.web.core.data.UiState
import app.bloomey.web.core.data.models.PageResponse
import app.bloomey.web.core.data.models.UpdateVideoRequest
import app.bloomey.web.core.data.models.Video

object VideoContract {
    data class State(
        val videos: List<Video> = emptyList(),
        val page: Int = 0,
        val nextPage: UiState<PageResponse<List<Video>>> = UiState.Initial,
        val lastPage: Boolean = false,
        val updateVideo: UiState<Boolean> = UiState.Initial,
        val deleteVideo: UiState<Boolean> = UiState.Initial,
    )

    sealed interface Inputs {
        data class GetVideos(val page: Int, val size: Int, val query: String) : Inputs
        data class DeleteVideo(val id: String) : Inputs
        data class UpdateVideo(val id: String, val request: UpdateVideoRequest) : Inputs
    }

    sealed interface Events
}
